<style lang="scss" scoped>

@import "@/scss/main.scss";

.fade-enter-active,
.fade-leave-active {
    transition: all 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
    transform: translateY(-20%);
    opacity: 0;
}

.scale-enter-active,
.scale-leave-active {
  transition: all 0.5s ease;
}

.scale-enter-from,
.scale-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

.nav-item {
  border-bottom: none;
  background: $light-grey;
}

.nav-item  .nav-link {
  color: lighten($dark-grey, 15%);
}

.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
  color: $body-color;
  background-color: #FFFFFF;
  border-color: #cbd5e1 #cbd5e1 #FFFFFF;
}

</style>
<template>
    <Content>
       <div v-if="!isProfileSelected" class="row mt-3 mb-2">
            <div class="col-12">
                <h2>Bewässerungs-App Mobil</h2>
                <p>
                    Die ALB garantiert dem Nutzer der App die ausschließlichen Rechte an den von ihm
                    erhobenen Daten. Eine unwillentliche Weitergabe der Daten an Dritte ist ausgeschlossen.
                    Eine mögliche Datenweitergabe kann nur durch aktives Handeln des jeweiligen Nutzers
                    veranlasst werden. Weitere Informationen finden Sie <router-link to="/info" class="content-link">hier</router-link>.
                </p>
            </div>
        </div>
        
        <div class="row">
             <div v-if="!isProfileSelected" class="col-12" >
                <div class="page-pretitle">
                </div>
                <h2 class="page-title_">
                    Dokumentation starten
                </h2>
            </div>
            <div v-else class="col-12">
                <div class="page-pretitle">
                    Erfassen & Dokumentieren
                </div>
                <h2 class="page-title">
                    Gewählter Schlag
                </h2>
            </div>
        </div>
        
        <div class="row mt-1">
            <div class="col-12">
                <ProfileSelect :profile="profile" :disabled="true"></ProfileSelect>
            </div>
        </div>
        
        <div v-if="isProfileSelected" class="row mt-3">
            <div class="col-12">
                <div class="page-pretitle">
                    Art der Dokumentation
                </div>
            </div>
        </div>
        
        <section v-if="isProfileSelected" :key="profileKey" >
            <div class="row mt-2">
                <div class="col-12">
                    <div class="card">
                        <ul class="nav nav-tabs nav-fill" data-bs-toggle="tabs">
                            <li class="nav-item">
                                <router-link to="/withdrawal" class="nav-link" :class="{'active': activeTab == 'withdrawal'}" @click_="switchActiveTab('irrigation')" >
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon me-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                        <path d="M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z" />                          
                                    </svg>
                                    Entnahme
                                </router-link>
                            </li>
                             <li v-show="isWaterPointWell" class="nav-item">
                                <router-link to="/level" class="nav-link" :class="{'active': activeTab == 'level'}" @click_="switchActiveTab('level')" >
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon me-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                        <circle cx="14" cy="6" r="2"></circle>
                                        <line x1="4" y1="6" x2="12" y2="6"></line>
                                        <line x1="16" y1="6" x2="20" y2="6"></line>
                                        <circle cx="8" cy="12" r="2"></circle>
                                        <line x1="4" y1="12" x2="6" y2="12"></line>
                                        <line x1="10" y1="12" x2="20" y2="12"></line>
                                        <circle cx="17" cy="18" r="2"></circle>
                                        <line x1="4" y1="18" x2="15" y2="18"></line>
                                        <line x1="19" y1="18" x2="20" y2="18"></line>
                                    </svg>
                                    Ruhewasserstand
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/precipitation" class="nav-link" :class="{'active': activeTab == 'precipitation'}" @click_="switchActiveTab('precipitation')">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon me-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                        <path d="M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7" />
                                        <path d="M11 13v2m0 3v2m4 -5v2m0 3v2" />
                                    </svg>
                                    Niederschlag
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <transition name="scale">
                <div v-if="activeTab == 'withdrawal'" class="row mt-2">
                    <div class="col-12">
                        <Irrigation :profile="profile"></Irrigation>                  
                    </div>
                </div>
            </transition>
            <transition name="scale">
                <div v-if="activeTab == 'level' && isWaterPointWell" class="row mt-2">
                    <div class="col-12">
                        <Level :profile="profile"></Level>                  
                    </div>
                </div>
            </transition>
            <transition name="scale">
                <div v-if="activeTab == 'precipitation'" class="row mt-2">
                    <div class="col-12">
                        <Precipitation :profile="profile"></Precipitation>                     
                    </div>
                </div>
            </transition>
        </section>
    </Content>
</template>

<script>

import Content from '@/components/Content.vue';
import ProfileSelect from '@/components/profile/ProfileSelect.vue';
import Precipitation from '@/components/precipitation/Precipitation.vue';
import Irrigation from '@/components/irrigation/Irrigation.vue';
import Level from '@/components/level/Level.vue';

export default {
    name: 'Home',
	components: {
      Content,
      ProfileSelect,
      Precipitation,
      Irrigation,
      Level
	},
    inject: [
        'state',
        'utils'
    ],
    data: function () {
        return {
            activeTab: 'withdrawal',
            tabNames: ['withdrawal', 'level', 'precipitation']
        }
    },
    computed: {
        profile: function () {
            let profile = this.state.profile.item();
            return profile ? profile: {};
        },
        isProfileSelected: function () {
            return !this.utils.isDataTypeFalse(this.profile);
        },
        waterPoint: function () {
            let waterPoint = this.state.actions.waterPoint.get(this.profile.waterPointId);
            return waterPoint ? waterPoint: {};
        },
        isWaterPointWell: function () {
            return this.waterPoint.typ === 'brunnen';
        },
        profileKey: function () {
            return [this.profile.id, this.profile.year].join('-');
        }  
    },
    methods: {
        isActiveTab: function (tabName) {
            return (this.activeTab == tabName);
        },
        switchActiveTab: function (tabName) {
            if (this.tabNames.includes(tabName)) {
                this.activeTab = tabName;
            }
        }
    },
    mounted: function () {
        
    },
    watch: {
        '$route.path': {
              handler (new_value) {
                    let tabName = new_value.replace('/', '');
                    this.switchActiveTab(tabName);
              },
              immediate: true            
        }
    },
    beforeRouteEnter() {
        
    }
}
</script>
